// Libs
import React from 'react';
import { Typography, Box } from '@mui/material';

// Components
import Rating from '../../../Rating';
import ProductInfoFields from './ProductInfoFields';
import OrderInfoFields from './OrderInfoFields';
import OrderProductQtyBlock from './OrderProductQtyBlock';
import ProductImageColumn from './ProductImageColumn';

// Hooks
import useOrderProductDetails from './useOrderProductDetails';

const OrderProductDetails = ({
  productId,
  order,
  orderItem,
  addressesCount,
  isRecurring,
}) => {
  const {
    product,
    isUnavailableForOrder,
    unavailableLabel,
    unavailableWatermark,
    theme,
    isMobileMode,
    classes,
    cx,
    totalOrdered,
    piRequiredText,
    shippedToText,
  } = useOrderProductDetails({ productId, order, orderItem, addressesCount });

  const {
    product_description: description,
    prepack_quantity: perUnitQty,
    rating: isRatable,
    size_vers: sizeVers,
  } = product || {};

  const {
    order_sn: orderId,
    created: orderDate,
    ship_date: shipDate,
    address,
  } = order;

  return (
    <Box
      display="flex"
      gap={theme.spacing(3.75)}
      flexDirection={isMobileMode ? 'column-reverse' : 'row'}
      height="fit-content"
      pb={{ md: 2, xs: 2 }}>
      <Box display="flex" flexDirection="column" className={classes.leftPart}>
        <Typography variant="h2" className={classes.header}>
          {description}
        </Typography>
        <Typography variant="textSm" mb={0.5}>
          {sizeVers}
        </Typography>
        {isRatable && <Rating withTooltip={false} product={product} />}
        {isMobileMode && (
          <OrderProductQtyBlock
            orderItem={orderItem}
            addressesCount={addressesCount}
            isRecurring={isRecurring}
            perUnitQty={perUnitQty}
            totalOrdered={totalOrdered}
            classes={classes}
            showApproval
          />
        )}
        <ProductInfoFields
          product={product}
          piRequiredText={piRequiredText}
          isUnavailableForOrder={isUnavailableForOrder}
          unavailableLabel={unavailableLabel}
          classes={classes}
          cx={cx}
        />
        <OrderInfoFields
          orderId={orderId}
          orderDate={orderDate}
          shipDate={shipDate}
          address={address}
          shippedToText={shippedToText}
          classes={classes}
        />
        {!isMobileMode && (
          <OrderProductQtyBlock
            orderItem={orderItem}
            addressesCount={addressesCount}
            isRecurring={isRecurring}
            perUnitQty={perUnitQty}
            totalOrdered={totalOrdered}
            classes={classes}
          />
        )}
      </Box>
      <ProductImageColumn
        product={product}
        unavailableWatermark={unavailableWatermark}
        classes={classes}
      />
    </Box>
  );
};

export default OrderProductDetails;
